// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1zkRb","label":"SetPasswdForm_label__4P8ZN"};